// Global
import React from 'react';

// Local
import { Content } from '@generated/Content/PromoBanner.model';
import { PromoBanner } from './PromoBanner';
import ImageWrapper from 'components/helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';
import PlainTextWrapper from 'components/helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import RichTextWrapper from 'components/helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import LinkWrapper from 'components/helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import styles from './PromoBanner.module.scss';
import { Themes } from 'lib/themes';

type PromoBannerProps = Content.PromoBanner.PromoBanner_Component;

export const Default = (props: PromoBannerProps) => {
  /*
   * Rendering
   */

  if (!props.fields) {
    return <></>;
  }

  return (
    <PromoBanner
      theme={props.params?.theme as Themes}
      image={
        <ImageWrapper
          className={styles.image}
          field={props.fields?.image}
          fallbackWidth={1600}
          fallbackHeight={1067}
        />
      }
      icon={<ImageWrapper field={props.fields?.icon} fallbackWidth={256} fallbackHeight={256} />}
      eyebrow={<PlainTextWrapper field={props.fields?.eyebrow} />}
      headline={<PlainTextWrapper field={props.fields?.headline} />}
      subhead={<PlainTextWrapper field={props.fields?.subhead} />}
      description={<RichTextWrapper field={props.fields?.body} />}
      cta1={
        <LinkWrapper
          field={props.fields?.cta1}
          ctaComponentClass="component-feature-split-color-cta-1-color"
          ctaStyle="filled"
          contentResultAnalytics={{
            contentListName: props.fields?.headline?.value?.trim() || undefined,
          }}
        />
      }
      cta2={
        <LinkWrapper
          field={props.fields?.cta2}
          ctaComponentClass="component-feature-split-color-cta-2-color"
          ctaStyle="outline"
          contentResultAnalytics={{
            contentListName: props.fields?.headline?.value?.trim() || undefined,
          }}
        />
      }
    />
  );
};
